import {INVITES} from '../actionTypes'
import {reducerFactory} from '../../lib/asyncUtil'

export default reducerFactory(INVITES)
